import { useContext } from "react"
import { PriceContext } from "../../PriceContext"
import * as styles from "../../newStyles.module.scss"

const icon1 = require("./icons/1.svg")
const icon2 = require("./icons/2.svg")
const icon4 = require("./icons/icon4.svg")

const Info = () => {
  const { text } = useContext(PriceContext)

  const items = [
    {
      icon: icon1,
      text: text.range.unlimitedSeats,
      iconClass: "",
      alt: "Неограниченное количество операторов",
    },
    {
      icon: icon2,
      text: text.range.aboutQuota,
      iconClass: "",
      alt: "Информация о лимитах",
    },
    {
      icon: icon4,
      text: text.range.nds,
      iconClass: "",
      alt: "Информация о НДС",
    },
  ]

  return (
    <ul className={styles.infoList}>
      {items.map((item, index) => (
        <li key={index} className={styles.infoItem}>
          <img src={item.icon.default} alt={item.alt} className={item.iconClass} />
          <p dangerouslySetInnerHTML={{ __html: item.text }} />
        </li>
      ))}
    </ul>
  )
}

export default Info
